import { ICrudLocale } from '@app/i18n/interface';

export const DASHBOARD_KPIS_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  KPI: {
    LABEL: {
      SINGULAR: 'Indicador',
      PLURAL: 'Indicadores',
    },
    FIELD: {},
    TITLE: 'Actividad del periodo',
    SUBTITLE: 'Todo lo de esta sección cuenta solo las reservas creadas en las fechas elegidas.',
    EMPTY: 'Sin datos para el rango elegido.',
    RANGE: {
      LABEL: 'Fechas',
      LAST_DAYS: 'Últimos {{ days }} días',
      TOO_LONG_TITLE: 'Rango demasiado amplio',
      TOO_LONG_DESC: 'El rango no puede superar los 366 días. Ajusta las fechas.',
    },
    CARD: {
      BOOKINGS: 'Reservas',
      BOOKINGS_NOTE: 'Creadas en el periodo, en cualquier estado.',
      REVENUE_SALE: 'Venta cobrada',
      REVENUE_NOTE: 'Solo reservas cobradas;',
      REVENUE_MARKUP: 'Margen',
      NET_SHORT: 'neto',
      MARGIN_OVER_SALE: 'sobre la venta cobrada',
      CANCELLATION_SHORT: 'cancelación',
      CANCELLATION_BASE: 'de todas las reservas',
      REFUND_SHORT: 'reembolso',
      REFUND_BASE: 'de las cobradas',
      // Pago diferido (P-8, REQ-069 y REQ-078): qué cuenta y qué no.
      PAY_LATER_NOTE: 'Las reservas de «pagar después» anuladas sin cobro cuentan como canceladas. Lo reservado y aún sin pagar no suma a la venta: está en Previsión de cobro.',
      AVERAGE_TICKET: 'Ticket medio',
    },
    CHART: {
      TITLE: 'Reservas por día',
      DESC: 'Reservas creadas cada día (día UTC).',
      EMPTY: 'Sin reservas en el rango elegido.',
      PEAK: 'Máximo: {{ count }} al día',
    },
    STATUS_TABLE: {
      TITLE: 'Reservas por estado',
      DESC: 'Reservas creadas en el periodo, por su estado actual.',
      STATUS: 'Estado',
      BOOKINGS: 'Reservas',
    },
    TOP: {
      DESTINATIONS_TITLE: 'Destinos con más ventas',
      HOTELS_TITLE: 'Hoteles con más ventas',
      ROOMS_DESC: 'Cuenta habitaciones cobradas, no reservas: una reserva puede tener varias.',
      DESTINATION: 'Destino',
      HOTEL: 'Hotel',
      ITEM_BOOKINGS: 'Habitaciones',
      ROOMS: 'Habitaciones',
      REVENUE: 'Venta',
    },
    CAMPAIGNS: {
      TITLE: 'Ventas por campaña',
      DESC: 'Reservas cobradas del periodo, según de dónde llegó la visita que acabó en compra.',
      SOURCE: 'Origen',
      MEDIUM: 'Medio',
      CAMPAIGN: 'Campaña',
      SALES: 'Ventas',
      REVENUE: 'Ingresos',
      MARGIN: 'Margen',
      MARGIN_SHARE: 'Margen %',
      EMPTY: 'No hay reservas en estas fechas, así que no hay ventas que repartir por origen.',
      HELP: 'Cuenta igual que la venta cobrada de arriba: reservas cobradas (las reembolsadas también), creadas en las fechas elegidas. Las reservas anteriores al 2 de noviembre de 2026 y las de visitantes que no aceptaron las cookies salen como «Sin atribución». Estas cifras no tienen por qué coincidir con las de Google Analytics.',
      BUCKET: {
        NONE: 'Sin atribución',
        DIRECT: 'Directo',
        NOT_SET: 'Origen sin identificar',
        OTHERS: 'Otras',
      },
    },
    ERROR: {
      TITLE: 'No pudimos cargar los indicadores',
      DESC: 'Ha fallado la consulta. Vuelve a intentarlo en un momento.',
    },
  },
};
